import React from "react";
import { Pie, PieChart, ResponsiveContainer, Tooltip, Cell } from "recharts";
import { formatNumber, toMonthLabel } from "./financialUtils";

export default function MetodosChartCard({
  pieData = [],
  pieTotal = 0,
  open,
  onToggle,
  onClose,
  draftFilters,
  setDraftFilters,
  centroOptions = [],
  cursoOptions = [],
  promoOptions = [],
  metodoYears = [],
  metodoMonths = [],
  onResetFilters,
  onApplyFilters,
}) {
  const pieColors = [
    "#2563eb",
    "#f59e0b",
    "#10b981",
    "#ec4899",
    "#8b5cf6",
    "#14b8a6",
    "#ef4444",
    "#22c55e",
    "#0ea5e9",
  ];

  return (
    <div className="card admin-section-card h-100">
      <div className="card-header bg-white border-0 d-flex justify-content-between align-items-center">
        <div>
          <h6 className="mb-0">Metodos de Pago</h6>
          <small className="text-muted">Distribucion de ingresos por metodo</small>
        </div>
        <div className="d-flex align-items-center gap-2">
          <div className="admin-filter-menu">
            <button
              type="button"
              className="btn btn-filter-chip"
              onClick={onToggle}
              aria-expanded={open}
            >
              <i className="bi bi-sliders2 me-1" />
              Filtros
              <i className="bi bi-chevron-down ms-1" />
            </button>
            {open && (
              <div className="admin-filter-panel">
                <div className="admin-filter-header">
                  <div>
                    <p className="admin-filter-title">Metodos de pago</p>
                    <small className="text-muted">Filtra por mes y ano</small>
                  </div>
                  <button type="button" className="btn btn-light btn-sm" onClick={onClose}>
                    <i className="bi bi-x-lg" />
                  </button>
                </div>
                <div className="row g-3">
                  <div className="col-12">
                    <label className="form-label">Centro</label>
                    <select
                      className="form-select"
                      value={draftFilters.centro_id}
                      onChange={(e) =>
                        setDraftFilters((prev) => ({
                          ...prev,
                          centro_id: e.target.value,
                          curso_id: "",
                          promocion_id: "",
                        }))
                      }
                    >
                      <option value="">Todos</option>
                      {centroOptions.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.alias || c.nombre || `Centro ${c.id}`}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-6">
                    <label className="form-label">Curso</label>
                    <select
                      className="form-select"
                      value={draftFilters.curso_id}
                      onChange={(e) =>
                        setDraftFilters((prev) => ({
                          ...prev,
                          curso_id: e.target.value,
                          promocion_id: "",
                        }))
                      }
                    >
                      <option value="">Todos</option>
                      {cursoOptions.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.nombre || `Curso ${c.id}`}
                        </option>
                      ))}
                    </select>
                  </div>
                        <div className="col-6">
                          <label className="form-label">Promocion</label>
                          <select
                            className="form-select"
                            value={draftFilters.promocion_id}
                            onChange={(e) =>
                              setDraftFilters((prev) => ({
                                ...prev,
                                promocion_id: e.target.value,
                              }))
                            }
                          >
                            <option value="">Todas</option>
                            {promoOptions.length ? (
                              promoOptions.map((p) => (
                                <option key={p.id} value={p.id}>
                                  {p.numero_promocion || p.nombre || `Promo ${p.id}`}
                                </option>
                              ))
                            ) : (
                              <option value="" disabled>
                                Sin promociones
                              </option>
                            )}
                          </select>
                        </div>
                  <div className="col-6">
                    <label className="form-label">Ano</label>
                    <select
                      className="form-select"
                      value={draftFilters.metodoYear}
                      onChange={(e) =>
                        setDraftFilters((prev) => ({
                          ...prev,
                          metodoYear: e.target.value,
                          metodoMonth: e.target.value === "all" ? "all" : prev.metodoMonth,
                        }))
                      }
                    >
                      <option value="all">Todos</option>
                      {metodoYears.map((year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-6">
                    <label className="form-label">Mes</label>
                    <select
                      className="form-select"
                      value={draftFilters.metodoMonth}
                      disabled={draftFilters.metodoYear === "all"}
                      onChange={(e) => setDraftFilters((prev) => ({ ...prev, metodoMonth: e.target.value }))}
                    >
                      <option value="all">Todos</option>
                      {metodoMonths.map((month) => (
                        <option key={month} value={month}>
                          {toMonthLabel(month)}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="admin-filter-actions">
                  <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onResetFilters}>
                    Restablecer
                  </button>
                  <button type="button" className="btn btn-primary btn-sm" onClick={onApplyFilters}>
                    Aplicar
                  </button>
                </div>
              </div>
            )}
          </div>
          <span className="dashboard-chip">
            <i className="bi bi-pie-chart me-1" />
            {pieData.length}
          </span>
        </div>
      </div>
      <div className="card-body chart-body">
        {pieData.length && pieTotal ? (
          <div className="d-flex flex-wrap gap-3 align-items-center">
            <div className="chart-container-small">
              <ResponsiveContainer width={260} height={260}>
                <PieChart>
                  <Pie data={pieData} dataKey="value" nameKey="metodo" cx="50%" cy="50%" innerRadius={50} outerRadius={90}>
                    {pieData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={pieColors[index % pieColors.length]} stroke="#ffffff" />
                    ))}
                  </Pie>
                  <Tooltip formatter={(value, name) => [formatNumber(value, true), name || "Metodo"]} />
                </PieChart>
              </ResponsiveContainer>
            </div>
            <div className="flex-grow-1 d-flex flex-column gap-2 justify-content-center">
              {pieData.map((p, idx) => {
                const color = pieColors[idx % pieColors.length];
                const percent = pieTotal ? Math.round((p.value / pieTotal) * 100) : 0;
                return (
                  <div
                    key={idx}
                    className="d-flex align-items-center justify-content-between gap-2 small py-1 px-2 rounded"
                    style={{ background: "#f8fafc", border: "1px solid #e5e7eb" }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      <span style={{ width: 12, height: 12, background: color, borderRadius: 2, display: "inline-block" }} />
                      <span className="fw-semibold">{p.metodo || "Sin metodo"}</span>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <span className="badge bg-light text-dark border">{percent}%</span>
                      <span className="fw-semibold">{formatNumber(p.value, true)}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <div className="chart-empty text-muted">Sin datos de metodos</div>
        )}
      </div>
    </div>
  );
}
